import { useMutation } from "@apollo/client";

import { useApolloGql } from "./index.js";

export const useApolloGqlMutation = ({
    actionDesc = "Make Apollo Gql Api Call",
    gql,
    errorHandler,
    successMessageOverride,
    errorMessageOverride
}) => {
    const [apiCallMutate, { loading }] = useMutation(gql);

    const { apiCall } = useApolloGql({
        actionDesc,
        apiCall: apiCallMutate,
        errorHandler,
        successMessageOverride,
        errorMessageOverride
    });

    return {
        apiCall,
        loading
    };
};
